const agent = (state = null, action) => {
    switch (action.type) {
        case 'SET_AGENT':
            state = action.agent;
            return state;
        default: return state;
    }
};

export default agent;